import { Observable } from 'rxjs';
import { UseCase } from '../../../base/use-case';
import { DataTypeCanalEntity } from '../../../../data/repositories/configuration/entities/type-canal.entity';
import { TypeCanalModel } from '../../../models/configuration/type-canal.model';
import { ConfigurationRepository } from '../../../repositories/configuration.repository';


export class InsertTypeCanalUseCase implements UseCase<DataTypeCanalEntity, TypeCanalModel> {
    constructor(private typeCanal: ConfigurationRepository) { }
    execute(
        params: DataTypeCanalEntity,
    ): Observable<TypeCanalModel> {
        return this.typeCanal.insertTypeCanal(params);
    }
}
